import { queryOptions } from '@tanstack/react-query';

import { BROWSER_PUSH } from '../../push/browser';
import { readThisDevice } from '../../push/device';
import { CTL_GC, ctlKeys } from '../../utils/query-keys';

export const pushDeviceQueryOptions = () =>
  queryOptions({
    queryKey: ctlKeys.pushDevice(),
    queryFn: ({ signal }) => readThisDevice(BROWSER_PUSH, signal),
    staleTime: Infinity,
    gcTime: CTL_GC,
    retry: false,
  });
